'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagDoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.935e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -0.000446975 6.66667 6.935e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 8H12V0H6.935e-05L0 8Z",
          fill: "#083D7A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 20H28V12H16V20Z",
          fill: "#083D7A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H12V12H0V20Z",
          fill: "#DF1E35"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 8H28V0H16V8Z",
          fill: "#DF1E35"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5858 8.58579C11.8047 9.36684 11.8047 10.6332 12.5858 11.4142C13.3668 12.1953 14.6332 12.1953 15.4142 11.4142C16.1953 10.6332 16.1953 9.36684 15.4142 8.58579L14.9428 9.05719C15.4635 9.57789 15.4635 10.4221 14.9428 10.9428C14.4221 11.4635 13.5779 11.4635 13.0572 10.9428C12.5365 10.4221 12.5365 9.57789 13.0572 9.05719L12.5858 8.58579Z",
          fill: "#0F6D1A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 10.6667C14.3682 10.6667 14.6667 10.3682 14.6667 10C14.6667 9.63181 14.3682 9.33333 14 9.33333C13.6318 9.33333 13.3333 9.63181 13.3333 10C13.3333 10.3682 13.6318 10.6667 14 10.6667Z",
          fill: "#042F60"
        }
      )
    ]
  }
);
const VpFlagDoAsset = forwardRef(FlagDoAsset);

export { VpFlagDoAsset as default };
